import is from "./filter-set.js";
export default class us {
  constructor(t, s) {
    (this.productId = t), (this.if = s), (this.productId = t), (this.if = s);
  }
  sf(t) {
    if (null == this.productId || null == this.if) return !1;
    const s = t[0],
      i = t[1];
    return s === this.productId && this.if.sf(i);
  }
  static fromJson(t) {
    return new us(
      t ? t.product_id : null,
      t ? is.fromJson(t.property_filters) : null,
    );
  }
  gt() {
    return { id: this.productId, pf: this.if ? this.if.gt() : null };
  }
}
